const ORBITRON_FONT_ID = 'aumhum-orbitron-font'
const ORBITRON_FONT_HREF = 'https://fonts.googleapis.com/css2?family=Orbitron:wght@400;700&display=swap'

const NOTO_DEVANAGARI_FONT_ID = 'aumhum-noto-devanagari-font'
const NOTO_DEVANAGARI_FONT_HREF =
  'https://fonts.googleapis.com/css2?family=Noto+Sans+Devanagari:wght@400;900&display=swap'

const fontPromises = {}

function ensureFontLoaded(id, href) {
  if (typeof document === 'undefined') {
    return Promise.resolve()
  }

  if (document.getElementById(id)) {
    return Promise.resolve()
  }

  if (fontPromises[id]) {
    return fontPromises[id]
  }

  fontPromises[id] = new Promise((resolve) => {
    const link = document.createElement('link')
    link.id = id
    link.rel = 'stylesheet'
    link.href = href
    link.onload = () => resolve()
    link.onerror = () => resolve()
    document.head.appendChild(link)
  })

  return fontPromises[id]
}

export function ensureOrbitronFontLoaded() {
  return ensureFontLoaded(ORBITRON_FONT_ID, ORBITRON_FONT_HREF)
}

export function ensureNotoSansDevanagariLoaded() {
  return ensureFontLoaded(NOTO_DEVANAGARI_FONT_ID, NOTO_DEVANAGARI_FONT_HREF)
}
